import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import AddressList from './address-list.component';
import AddressCreate from './address-create.component';
import AddressView from './address-view.component';
import AddressEdit from './address-edit.component';
import AddressCopy from './address-copy.component';
import AddressDelete from './address-delete.component';

interface Props {
  root?: string;
}

export const AddressRouteProduct: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>
      <Route path={`${props.root||''}/addressproduct/create`} render={(params) => <AddressCreate {...params} key={params.history.location.key} caption='Create Link' parentType='product' />} />    
      <Route path={`${props.root||''}/addressproduct/view`} render={(params) => <AddressView {...params} key={params.history.location.key} caption='View Link' parentType='product' />} />        
      <Route path={`${props.root||''}/addressproduct/edit`} render={(params) => <AddressEdit {...params} key={params.history.location.key} caption='Edit Link' parentType='product' />} />        
      <Route path={`${props.root||''}/addressproduct/copy`} render={(params) => <AddressCopy {...params} key={params.history.location.key} caption='Duplicate Link' parentType='product' />} />     
      <Route path={`${props.root||''}/addressproduct/delete`} render={(params) => <AddressDelete {...params} key={params.history.location.key} caption='Delete Link'/>} />        
      <Route path={(props.root||'') + '/addressproduct'} render={(params) => <AddressList {...params} key={params.history.location.key} root={props.root} caption='Link' parentType='product' />} /> 
    </Switch>
  );
}
